import { render, staticRenderFns } from "./DefaultEditReferences.vue?vue&type=template&id=ecc212a6&"
import script from "./DefaultEditReferences.vue?vue&type=script&lang=ts&"
export * from "./DefaultEditReferences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports